import { render, staticRenderFns } from "./IconCrypto.vue?vue&type=template&id=475f3cde&"
import script from "./IconCrypto.vue?vue&type=script&lang=js&"
export * from "./IconCrypto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports